module.exports = __webpack_public_path__ + "img/42-ABITO-YUKI-U-COLORI-LINO-STAMPE-LINO18.5d771dc0.jpg";